function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.565 2.753c.345 0 .689.002 1.034-.001.062-.001.081.017.081.08-.002.677-.002 1.355 0 2.033 0 .062-.018.081-.081.081-.689-.002-1.378-.002-2.066 0-.063 0-.081-.018-.081-.08.002-.678.002-1.356 0-2.034 0-.062.017-.081.08-.08.345.003.689.001 1.033.001zM1.107 7.678c-.341 0-.683-.001-1.025.001C.022 7.68 0 7.667 0 7.602c.002-.675.002-1.351 0-2.026 0-.061.016-.08.08-.08.686.002 1.373.002 2.059-.001.075 0 .089.027.089.093-.002.67-.003 1.339 0 2.008 0 .069-.021.084-.087.084-.345-.004-.689-.002-1.034-.002zM5.453 1.102c0-.34.001-.681-.001-1.021C5.451.021 5.466 0 5.531 0c.689.002 1.378.002 2.067 0 .061 0 .082.015.082.079-.002.68-.002 1.361 0 2.042 0 .061-.015.081-.08.081-.689-.002-1.377-.002-2.066.001-.073 0-.083-.027-.082-.088.002-.338.001-.675.001-1.013z",
  fill: "var(--logo-primary-color)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.453 6.595c0-.338.002-.676-.001-1.013-.001-.065.014-.086.083-.086.687.003 1.373.003 2.059 0 .069 0 .086.021.085.087-.002.672-.002 1.344 0 2.017.001.062-.017.08-.08.079a285.11 285.11 0 00-2.068.001c-.064 0-.08-.02-.079-.081.003-.335.001-.67.001-1.004z",
  fill: "var(--logo-secondary-color)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.851 2.753c.335 0 .671.002 1.006-.001.065-.001.094.01.093.085-.003.675-.002 1.35 0 2.025 0 .068-.02.084-.086.084-.683-.003-1.366-.003-2.049 0-.069 0-.085-.021-.085-.086.002-.675.002-1.35 0-2.025 0-.069.022-.084.087-.083.344.003.689.001 1.034.001zM4.949 6.593c0 .332-.002.664.001.996.001.066-.013.091-.087.091-.681-.003-1.361-.003-2.042 0-.069 0-.092-.017-.091-.088.003-.67.002-1.34 0-2.009 0-.064.013-.088.084-.088.683.003 1.367.003 2.05.001.067-.001.087.017.086.084-.003.338-.001.676-.001 1.013z",
  fill: "var(--logo-primary-color)"
});

var SvgLogoMinimal = function SvgLogoMinimal(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 8 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref, _ref2, _ref3);
};

export default SvgLogoMinimal;